module.exports = __webpack_public_path__ + "4cf5d3ec48501313d15c9a8fc5fe9a29.svg";